export default {"src":"/_next/static/media/money.45d96395.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};